import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, pluck, difference, head } from 'ramda';

import { initialValues } from '../../../../../../../../forms/bonusForm';
import BonusPresenter, {
  TYPES,
} from '../../../../../../../../presenters/Membership/BonusPresenter';

import BonusCell from './components/BonusCell';
import NewBonusForm from './components/NewBonusForm';

const BonusesTable = (props) => {
  const { bonuses, membershipId, onDialogOpen, onBonusCreate } = props;

  const currentBonusTypes = pluck(['bonusType'], bonuses);
  const availableBonusTypes = difference(TYPES, currentBonusTypes);

  const handleCreateBonus = (values) => {
    const bonusType = values.bonusType;
    const bonusParams = { bonus: { bonusType } };
    onBonusCreate(membershipId, bonusParams);
  };

  return (
    <table className="bonuses-table">
      <thead>
        <tr>
          <th className="cell">Amount</th>
          <th className="cell">State</th>
          <th className="cell">Bonus type</th>
          <th className="cell">Created at</th>
          <th className="cell">Actions</th>
        </tr>
      </thead>
      <tbody>
        {bonuses.map((bonus) => (
          <BonusCell
            key={BonusPresenter.id(bonus)}
            bonus={bonus}
            onDeleteDialogOpen={onDialogOpen}
          />
        ))}
        {!isEmpty(availableBonusTypes) && (
          <NewBonusForm
            onSubmit={handleCreateBonus}
            initialValues={initialValues({
              bonusType: head(availableBonusTypes),
            })}
            availableBonusTypes={availableBonusTypes}
          />
        )}
      </tbody>
    </table>
  );
};

export default BonusesTable;

BonusesTable.propTypes = {
  bonuses: PropTypes.arrayOf(BonusPresenter.shape()).isRequired,
  membershipId: PropTypes.string.isRequired,
  onDialogOpen: PropTypes.func.isRequired,
  onBonusCreate: PropTypes.func.isRequired,
};
